import React from "react";

// Official DM Solutions Group logo (brand asset, transparent PNG for dark backgrounds)
const SRC = {
  notag: "/logo-dm-notag.png",
  full: "/logo-dm.png",
  mark: "/logo-dm-mark.png",
};
const RATIO = { notag: 4.07, full: 3.28, mark: 1.2 };

export const Logo = ({ variant = "full", height = 46, className = "" }) => (
  <img
    src={SRC[variant]}
    alt="DM Solutions Group — Energia. Innovazione. Valore."
    style={{ height, width: height * RATIO[variant] }}
    className={`object-contain select-none ${className}`}
    draggable={false}
  />
);
